import React from 'react';

import { Article } from '../../../../../types/items';
import useStyles from '../styles';
import ActivityBaseComment from '../ActivityBaseComment';

type Props = {
  article: Article;
};

const ActivityOrderStatusComment = ({ article }: Props) => {
  const classes = useStyles();
  const name = article.ref.user?.full_name_first_last;

  if (article.order_status === 'cancelled') {
    return (
      <ActivityBaseComment
        header={(
          <>
            <span className={classes.accent}>{name}</span>
            {' '}
            has
            {' '}
            <span className={classes.alertMessage}>canceled</span>
            {' '}
            the
            {' '}
            <span className={classes.italicAccent}>{article.ref.order?.title}</span>
            {' '}
            order.
            <span className={classes.timestamp}>{article.ref.created_age}</span>
          </>
        )}
        content={article.message || ''}
      />
    );
  }


  return null;
};

export default ActivityOrderStatusComment;
